import React from 'react';

export default class Occasions extends React.Component {

    constructor(props) {
        super(props);

        this.occasions = props.occasions
        /*
        this.occasions = [
            {
                id: 1,
                name: 'Team Building'
            },
            {
                id: 2,
                name: 'Celebration (Birthday party)'
            },
            {
                id: 3,
                name: 'Bachelorette Party'
            },
            {
                id: 4,
                name: 'Other'
            },
        ];*/
    }

    fetchData = () => {
        fetch('http://example.com/movies.json', {
            body: JSON.stringify({
                data: 'occasion',
                id: 0,
            })
        })
            .then((response) => response.json())
            .then((data) => console.log(data));
    }

    onClick = (occasionId) => {
        let data = {
            occasionId: occasionId
        }
        this.props.setData(data);
    }

    buildBoxes() {
        return this.occasions.map((item) => {
            let className = parseInt(item.id) === parseInt(this.props.form?.occasionId) ? 'occasion_item_highlighted' : 'occasion_item';

            return (
                <div className={className} key={'occasion_' + item.id} onClick={() => this.onClick(item.id)}>
                    {item.name}
                </div>
            );
        });
    }

    render() {
        return (
            <>
                {this.buildBoxes()}
            </>
        );
    }
}